import React from "react";
import Work from "@material-ui/icons/Work";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";

import Icon from "../../../components/Icon";
import TabsPlan from "./TabsPlan";
import styles from "./styles";

export const TabsSection = ({ sections, type }) => {
  const classes = styles();
  return (
    <section className={classes.titleSectionContainer}>
      <div>
        <div>
          <div className={classes.titleContainer}>
            <div className={classes.titleText}>
              <div className={classes.lineTitle} />
              <div className={classes.titleSection}>Contamos con</div>
            </div>
            <div className={classes.containerButtons}>
              <a href="#faq" target="" className={classes.buttonContainer}>
                Preguntas frecuentes
              </a>
              <a href="#guide" target="" className={classes.buttonContainer}>
                Guía de uso
              </a>
              <a href="#contact" target="" className={classes.buttonContainer}>
                Contáctenos
              </a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <TabsPlan sections={sections} type={type} />
      </div>
    </section>
  );
};

TabsSection.propTypes = {
  sections: PropTypes.any,
  type: PropTypes.any
};
